import React from 'react';
import { ControlledRadioGroup } from 'src/components/BeaconV2Components/common/ControlledRadioGroup';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { dataStructures } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants';

export const EntitySelect = () => {
  const {
    selections: { control, setValue }
  } = usePresentationFormContext();

  const handleChange = (newValue: string) => {
    setValue('entityId', { id: '', name: '' });
    setValue('categoryIds', []);
    setValue('subcategoryIds', []);
  };

  return (
    <ControlledRadioGroup
      control={control}
      name="entityType"
      options={dataStructures}
      label="Data Structure"
      description="Select which data structure you would like to use for this presentation."
      onChange={handleChange}
      gap={80}
    />
  );
};
